import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import NoDataMsg from 'library/noData';
import EditorAttachMoneyIcon from '@mui/icons-material/AttachMoney';
import GenericTable from 'screens/components/advanced/GenericTable';

let branchSummaryColumns = [
    { key: "BranchName", label: "Branch" },
    { key: "MasterCard", label: "Credit-MasterCard" },
    { key: "Visa", label: "Credit-Visa" },
    { key: "AMEX", label: "Credit-AMEX" },
    { key: "Other", label: "Credit-Other" },
    { key: "Credit", label: "Credit Total" },
    { key: "Debit", label: "Debit Total" },
    { key: "Cash", label: "Cash Total" }
]
const Body = ({ creditPayments, endDate, beginDate }) => (

    <div>
        {
            creditPayments.details && creditPayments.details.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                creditPayments.details && creditPayments.details.length > 0 ?
                    //If there's DATA
                    <div>
                        <div className="row m-0">
                            <div className="text-center list_header">
                                {beginDate ?
                                    <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                        {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                    : ""}
                            </div>
                        </div>
                        <div className="table-responsive">
                            <div className="row m-0 mb-2 center_xs col-4-p-0 col-4-em-0" >
                                <div className="col-lg-12 title_summary">
                                    <h3 className="m-0">SUMMARY</h3>
                                </div>{/* row - Date */}

                                <div className="row m-0 mb-2">
                                    <div className="discount-report-table">
                                        <GenericTable
                                            className="table_center tableHeaderwhiteColorFont"
                                            stripedRows={true}
                                            columns={branchSummaryColumns}
                                            rows={creditPayments.summary.map((item) => {
                                                return {
                                                    BranchName: item.branchName,
                                                    MasterCard: item.creditMasterCardNet,
                                                    Visa: item.creditVisaNet,
                                                    AMEX: item.creditAMEXNet,
                                                    Other: item.creditOtherNet,
                                                    Credit: item.creditNet,
                                                    Debit: item.debitNet,
                                                    Cash: item.cashNet
                                                }
                                            })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            {                                
                                creditPayments.details.map((item, index) => {

                                    return (
                                        <div className="row m-0 mb-2 center_xs col-4-p-0 col-4-em-0" key={index}>
                                            <div className="col-lg-12 title_th">
                                                <h3 className="m-0">{moment(item.date).format('MMMM Do, YYYY')}</h3>
                                            </div>{/* row - Date */}

                                            <div className="col-lg-12 mb-1">
                                                <div className='row' >
                                                    <div className="col-lg-1 col-md-2 col-sm-2 col-xs-4 border-right text-right">
                                                        <label className="sm_label">Branch</label>
                                                        <p className="m-0 grey-text">{getDollarFormat(item.branchName)}</p>
                                                    </div> {/* Column Orders */}
                                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-4 border-right text-right">
                                                        <span className="sm_icon"><EditorAttachMoneyIcon /></span>
                                                        <label className="sm_label">MasterCard</label>
                                                        <h3 className="m-0 grey-text size_2vmax">{getDollarFormat(item.creditMasterCardNet)}</h3>
                                                    </div> {/* Column Orders */}

                                                    <div className="col-lg-1 col-md-2 col-sm-2 col-xs-4 border-right text-right">
                                                        <span className="sm_icon"><EditorAttachMoneyIcon /></span>
                                                        <label className="sm_label">Visa</label>
                                                        <h3 className="m-0 grey-text size_2vmax">{getDollarFormat(item.creditVisaNet)}</h3>
                                                    </div> {/* Column Orders */}

                                                    <div className="col-lg-1 col-md-2 col-sm-2 col-xs-4 border-right text-right">
                                                        <span className="sm_icon"><EditorAttachMoneyIcon /></span>
                                                        <label className="sm_label">AMEX</label>
                                                        <h3 className="m-0 grey-text size_2vmax">{getDollarFormat(item.creditAMEXNet)}</h3>
                                                    </div> {/* Column Orders */}

                                                    <div className="col-lg-1 col-md-2 col-sm-2 col-xs-6 border-right text-right mt-2_xs">
                                                        <span className="sm_icon"><EditorAttachMoneyIcon /></span>
                                                        <label className="sm_label">Other</label>
                                                        <h3 className="m-0 grey-text size_2vmax">{getDollarFormat(item.creditOtherNet)}</h3>
                                                    </div> {/* Column Orders */}

                                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-6 text-right mt-2_xs">
                                                        <span className="sm_icon"><EditorAttachMoneyIcon /></span>
                                                        <label className="sm_label">Total Credit Sales</label>
                                                        <h3 className="m-0 grey-text size_2vmax">{getDollarFormat(item.creditNet)}</h3>
                                                    </div> {/* Column Orders */}

                                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-6 text-right mt-2_xs">
                                                        <span className="sm_icon"><EditorAttachMoneyIcon /></span>
                                                        <label className="sm_label">Total Debit Sales</label>
                                                        <h3 className="m-0 grey-text size_2vmax">{getDollarFormat(item.debitNet)}</h3>
                                                    </div> {/* Column Orders */}

                                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-6 text-right mt-2_xs">
                                                        <span className="sm_icon"><EditorAttachMoneyIcon /></span>
                                                        <label className="sm_label">Total Cash Sales</label>
                                                        <h3 className="m-0 grey-text size_2vmax">{getDollarFormat(item.cashNet)}</h3>
                                                    </div> {/* Column Orders */}
                                                </div>

                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div> : ''
        }
    </div>
);

export default Body;